import { SiteUrls } from '@tableau/shared-urls';
import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';

import { QueryParameterHelper } from '../../../viz/helpers/QueryParameterHelper';
import { FilterFieldNames } from '../../models/IFilterClause';

// Return the query parameters that are in the hash as an object
export function getQueryParameters(): any {
  const search: any = WindowLocationService.getHashQueryObject();
  return search;
}

// Add the current query parameters that are in the hash to the given url
export function addQuery(url: string, omitOrderQueryParam: boolean = false, omitContentTypeQueryParam: boolean = false): string {
  let params = getQueryParameters();
  if (omitOrderQueryParam) {
    params = _.omit(params, UrlParamKeys.Order);
  }
  if (omitContentTypeQueryParam) {
    params = _.omit(params, FilterFieldNames.contentType);
  }
  return QueryParameterHelper.urlWithParams(url, params);
}

// TODO: This subclass should be removed.
// The remaining methods should either be moved to SiteUrls
// or to separate helpers. We should do that work when removing the mixedContentEnabled feature flag.

export class SpacesSiteUrls extends SiteUrls {

  constructor(config: { siteUrlName: string, queryString?: string }) {
    super({
      siteUrlName: config.siteUrlName,
      // Many existing call sites expect queryString to be filled in automatically
      queryString: config.queryString != null ? config.queryString : window.location.search,
    });
  }

  //
  // URLs go below here
  //

  public exploreSiteDataconnectionsUrl(): string {
    return this.datasourcesUrl() + '?' + FilterFieldNames.contentType + '=' + 'dataconnection';
  }

  public exploreDataConnectionUrl(dataConnectionId: string) {
    // This URL navigates to the data source by its Unified Datasource (connection) ID
      return this.datasourceDataConnectionUrl(dataConnectionId);
  }

  public userDataconnectionsUrl(username: string, domainName: string) {
    const url = this.userDatasourcesUrl(username, domainName);
    return url + '?' + FilterFieldNames.contentType + '=' + 'dataconnection';
  }

  public contentRootUrl(): string {
    return FeatureFlags.homePage ? this.homeUrl() : this.exploreUrl();
  }

  public contentRootPath(): string {
    return FeatureFlags.homePage ? this.homePath() : this.explorePath();
  }
}
